<template>
  <div
    ref="itemWrapper"
    tabindex="0"
    id="about"
    class="about page"
    @keyup.esc="returnHome"
  >
    <router-link to="/">
      <img
        class="close-view"
        src="@/assets/close.svg" alt=""
      >
    </router-link>
    <h1 class="about__title">About</h1>
    <div class="about__content">
      <div>Bruno Patyn (Ostend - Belgium, 1981)<br />
        MFA 2005 - LUCA School of Arts Brussels
      </div>
      <div>
        <p>Artist residencies</p>
        <ul>
          <li>2015 Artist in residence - Artscape Gibraltar Point (Toronto, CANADA)</li>
          <li>2015 Artist in residence - DRAWinternational (Caylus, France)</li>
          <li>2012 Founding of the Boiling Point Press printmaking studio (Berlin, Germany)</li>
          <li>2011-2014 Artist in residence - Guanlan Printmaking Base (Guanlan, PRC China)</li>
          <li>2011 Artist in residence - Guanlan Printmaking Base (Guanlan, PRC China)</li>
          <li>2010 Artist in residence - Frans Masereel Centrum (Kasterlee, Belgium)</li>
          <li>2008-2010 Masterprinter internship &amp; Artist in residence at Proyecto 'Ace (Buenos Aires, Argentine)</li>
          <li>2007 Artist in residence - Frans Masereel Centrum (Kasterlee, Belgium)</li>
        </ul>
        <p>Selected group exhibitions</p>
        <ul>
          <li>Galerie Albert Dumont - Brussels. Nov 2016</li>
          <li>'Oracle' &ndash; Artscape Gibraltar Point (Toronto, CANADA). SEP 2015</li>
          <li>'Cosmogony I' presentation. DRAWinternational projects (Caylus, Tarn-et-Garonne, France).</li>
          <li>'Architecture of the soul' Proyecto 'ACE SUB30 program (Buenos Aires, Argentine)</li>
        </ul>
        <p>Selected solo exhibitions</p>
        <ul>
          <li>Gallery ne9enpuntne9en (Roeselare, Belgium)</li>
          <li>'Cosmogony II' during The Artist Project 2015 (Toronto, CANADA)</li>
          <li>'New drawings' &ndash; The beat (Toronto, CANADA)</li>
          <li>'Cosmogony III' - Centre Culturelle Bellegarde (Toulouse, France)</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router"

export default {
  name: 'About',
  data() {
    return {}
  },
  mounted() {
    this.$refs.itemWrapper.focus()
  },
  methods: {
    returnHome: function () {
      router.push('/')
    }
  }
}
</script>

<style lang="scss">
  .about {

    &__title {
      margin-top: 0;
      padding-top: 65px;
      padding-left: 15px;
      color: gray;
    }

    &__content {
      max-width: 1100px;
      margin: 0 auto;
      padding: 50px 0;
    }
  }

  @media all and (max-width: 1130px) {

    .about {
      padding: 0 15px;

      &__title {
        padding-left: 0;
      }
    }

  }
</style>
